<template>
    <div class="shop-filter-field" :class="{'shop-filter-field--compact': compact}">
        <label v-if="!compact" class="shop-filter-label">{{ formField.title }}</label>

        <input
            type="number"
            autocomplete="off"
            v-model="value"
            @change="handleOnChange(value)"
            :placeholder="formField.title"
            class="shop-filter-input"
        >
    </div>
</template>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

input[type=number] {
    -moz-appearance: textfield;
}
</style>
<script>
export default {
    name: 'MyNumber',
    props: {
        formField: {
            required: true,
            type: Object,
        },
        onChangeHandler: {
            required: true,
            type: Function,
        },
        compact: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            value: '',
        }
    },

    methods: {
        handleOnChange(value) {
            this.value = value;

            this.onChangeHandler(
                `additional_data[${this.formField.slug}]`,
                value ? value : null,
                true
            )
        }
    },

    mounted() {
        if (this.selectedFilters[`additional_data[${this.formField.slug}]`] ?? false) {
            this.value = decodeURIComponent(this.selectedFilters[`additional_data[${this.formField.slug}]`]).replaceAll('+', ' ');
        }
    }
}
</script>
